const totalCommissionsPercentageIsValid = (commissions) => {
  const totalPercentageCommissions = commissions.reduce((total, commission) => total + parseFloat(commission.commission), 0)
  return totalPercentageCommissions === 100
}

export default totalCommissionsPercentageIsValid
